import { defineStore } from 'pinia';
import axios from 'axios';

export const useAccessStore = defineStore('access', () => {
    
    const accessMember = (userHash) => axios.get(`/api/v1/members/${userHash}/access`);
    const stopAccessMember = () => axios.get('/api/v1/stop-accessing-member');

    return { accessMember, stopAccessMember };
});
